import Fuse from 'fuse.js'

let observer
let bundleRoot

let container
let items
let input
let list

let searchData
let holder

let searchTemplate = `
    <div class="c-bundle-search">
        <label for="bundleSearch" class="u-visually-hidden">Search</label>
        <div class="c-bundle-search__wrap">
            <input type="text" id="bundleSearch" placeholder="Search item list" />
        </div>
    </div>
`

export function BundleSearch() {
    observer = new MutationObserver(mutationCallback)
    observer.observe(document.body, {
        childList: true,
        attributes: false,
        subtree: true
    })
}

function mutationCallback(mutationList) {
    if (bundleRoot) {
        return
    }

    let filterItems

    for (const mutation of mutationList) {
        if (!mutation.addedNodes.length) {
            continue
        }

        filterItems = Array.from(mutation.addedNodes).filter(
            (el) =>
                el.classList &&
                el.classList.contains('bundle-builder-app--bundle--integration--full-width')
        )

        if (filterItems.length) {
            bundleRoot = filterItems[0]
            initSearch()
        }
    }
}

function initSearch() {
    if (!bundleRoot) {
        return
    }

    container = bundleRoot.querySelector('.bundle-builder-app--content')
    list = container.querySelector('ul')

    addSearchInput()
    input = container.querySelector('#bundleSearch')

    items = container.querySelectorAll('.bundle-builder-app--bundle--product')
    items = Array.from(items).map((el) => {
        const title = el.querySelector('.bundle-builder-app--bundle--product-name')

        return {
            el,
            title: title.innerText
        }
    })

    holder = document.createElement('div')

    searchData = new Fuse(items, {
        keys: ['title'],
        threshold: 0.4
    })

    input.addEventListener('keyup', handleSearch)
}

function addSearchInput() {
    const div = document.createElement('div')
    div.innerHTML = searchTemplate

    container.insertBefore(div.firstElementChild, container.firstElementChild)
}

function handleSearch() {
    if (input.value.length >= 3) {
        const results = searchData.search(input.value)

        if (results.length) {
            hideItems()

            results.forEach(({ item }) => {
                list.appendChild(item.el)
            })
        } else {
            clearSearch()
        }
    } else {
        clearSearch()
    }
}

function hideItems() {
    items.forEach((item) => {
        holder.appendChild(item.el)
    })
}

function clearSearch() {
    items.forEach((item) => {
        list.appendChild(item.el)
    })
}
